import { render, staticRenderFns } from "./CreateGoalForm.vue?vue&type=template&id=2d099954"
import script from "./CreateGoalForm.vue?vue&type=script&lang=js"
export * from "./CreateGoalForm.vue?vue&type=script&lang=js"
import style0 from "./CreateGoalForm.vue?vue&type=style&index=0&id=2d099954&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports